import styles from './styles.module.scss';

const NavOptions = (props) => {


    
    return (
        <div className={`${styles.backgroundColorDark} ${props.xmas && styles['backgroundColorDark--xmas']} ${props.halloween && styles['backgroundColorDark--halloween']}`}
        style={{
            position: 'absolute',
            // padding: "1%",
            marginTop: '1.5%',
            borderRadius: '10px',
            textAlign: 'left',
            overflow: "hidden",
            zIndex: 999,
            width: '40vw'
        }}
        >
         {props.children}
        </div>
    );
}


export default NavOptions;